import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { BetStatus, useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_BOX, CARDS_TYPE, UNKNOWN_CARD_TYPE } from '../../enums/cardTypes';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';
import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { GambleText } from '../gambleText';
import { winningStore } from '../../store/winningStore';
import { GAMBLE_TYPES_ODD } from '../../enums/constants';

export const TableCardsSection = observer(() => {
  const {
    tableCards,
    selectedCardType,
    isShowGambleWin,
    isPickHoldActive,
    handleChangeHoldInCard,
    setPickCardIndex,
  } = cardsStore;
  const { gambleWin } = winningStore;
  const { isShowGamble, gambleType } = doBetStore;
  const { roundStatus, isBetsClosed } = gameStore;
  const { currencySymbolOrCode } = userInfoStore;
  const cardsIds = useIdsGenerator(CARDS_BOX);
  const t = useTranslation();

  const isShowGambleWinning = useMemo(() => {
    if (isShowGamble) {
      return tableCards.some((item) => item.card === UNKNOWN_CARD_TYPE);
    }
    return false;
  }, [isShowGamble, tableCards]);

  const handleSelectCard = useCallback(
    (index) => {
      if (isShowGamble) {
        setPickCardIndex(index + 1);
      } else {
        handleChangeHoldInCard(index);
      }
    },
    [handleChangeHoldInCard, setPickCardIndex, isShowGamble]
  );

  return (
    <div className={`poker-t-cards-wrp ${selectedCardType}`}>
      {CARDS_BOX.map((item, index) => (
        <div
          key={cardsIds[index]}
          className='poker-t-cards-item-wrp'
          onClick={() => handleSelectCard(index)}
        >
          <div
            className={`poker-t-cards-item ${
              // eslint-disable-next-line no-nested-ternary
              isShowGamble && isPickHoldActive && index !== 0
                ? 'held-hover'
                : gameStore.roundStatus === BetStatus.Pending && !doBetStore.isShowGamble
                ? 'held-hover'
                : ''
            } ${
              tableCards[index]?.isWin && tableCards[index].isWin && !Number.isInteger(gambleType)
                ? 'win'
                : ''
            } ${
              // eslint-disable-next-line no-nested-ternary
              (!isShowGambleWinning &&
                isShowGamble &&
                Number.isInteger(gambleType) &&
                index === 0) ||
              (isShowGamble && Number.isInteger(gambleType) && tableCards[index]?.isHold)
                ? ''
                : tableCards[index]?.isDisabled && tableCards[index].isDisabled
                ? 'disabled'
                : ''
            } ${
              // eslint-disable-next-line no-nested-ternary
              tableCards.length && tableCards.length === 5
                ? tableCards[index] && !tableCards[index]?.close
                  ? ''
                  : 'rotate-cards card-down'
                : tableCards[index] && !tableCards[index]?.close
                ? ''
                : 'rotate-cards'
            }
             ${tableCards[index]?.isHold && !isShowGamble ? 'held' : ''}
            ${
              tableCards[index]?.isWin && tableCards[index].isWin && isShowGamble
                ? 'win-gamble'
                : ''
            }
            `}
          >
            {/* added/remove class rotate-cards, held, win, disabled */}
            <div
              className={`poker-t-cards-front ${
                (isShowGamble &&
                  ((Number.isInteger(gambleType) && index === 0) ||
                    tableCards[index]?.hasOwnProperty('isDisabled') ||
                    tableCards[index]?.hasOwnProperty('isWin'))) ||
                roundStatus === BetStatus.Lose
                  ? 'cursor-default'
                  : ''
              } ${CARDS_TYPE[tableCards[index]?.card]}`}
            >
              {/* eslint-disable-next-line no-nested-ternary */}
              {tableCards[index]?.isHold && !tableCards[index]?.hasOwnProperty('isShowHeld') ? (
                <p
                  className={`card-held-block 
                ${isShowGamble && index === 0 && 'inactive-icon'}`}
                >
                  <i className='icon-hand card-held-bloc-hand' />
                  {
                    // eslint-disable-next-line no-nested-ternary
                    isShowGamble && Number.isInteger(gambleType)
                      ? // eslint-disable-next-line no-nested-ternary
                        index === 0
                        ? 'DEALER'
                        : tableCards[index]?.isWin
                        ? 'PICK'
                        : 'PICK'
                      : roundStatus === BetStatus.Lose
                      ? ''
                      : 'HELD'
                  }
                </p>
              ) : !tableCards[index]?.hasOwnProperty('isShowHeld') &&
                roundStatus === BetStatus.Pending &&
                (!isShowGamble || roundStatus === BetStatus.Lose) ? (
                <p className='card-held-block'>
                  <i className='icon-hand card-held-bloc-hand' />
                  HOLD
                </p>
              ) : null}
              {isShowGambleWin &&
                !isShowGambleWinning &&
                isShowGamble &&
                Number.isInteger(gambleType) &&
                tableCards[index]?.isWin && <div className='bonus-win-block'>WIN</div>}
            </div>
            <div className='poker-t-cards-back' />
          </div>
          {tableCards[index] && tableCards[index]?.close && (
            <div className='poker-t-cards-item rotate-cards new-card'>
              <div className='poker-t-cards-front' />
              <div className='poker-t-cards-back' />
            </div>
          )}
        </div>
      ))}
      {roundStatus === BetStatus.Pending && !isShowGamble && (
        <div className='click-card-txt-wrp click-to-hold'>
          <div className='tb-gamble-arrow-inner'>
            <span className='tb-gamble-arrow-bg' />
            <span className='tb-gamble-arrow-bg' />
          </div>
          <p className='click-card-txt'>{t('CLICK_TO_HOLD')}</p>
        </div>
      )}
      {!isBetsClosed && (
        <div className='click-card-txt-wrp place-you-bets'>
          <p className='click-card-txt'>{t('PLACE_YOUR_BETS')}</p>
          <div className='tb-gamble-arrow-inner'>
            <span className='tb-gamble-arrow-bg' />
            <span className='tb-gamble-arrow-bg' />
          </div>
        </div>
      )}
      {isShowGamble && roundStatus === BetStatus.Pending && (
        <GambleText
          gambleWin={gambleWin}
          isShowGambleWin={isShowGambleWinning}
          currencySymbolOrCode={currencySymbolOrCode}
        />
      )}
      {tableCards.some((item) => item.card === UNKNOWN_CARD_TYPE && gambleWin) && (
        <div className='possible-win-text-wrp'>
          <p className='possible-win-txt'>{t('POSSIBLE_WIN')}</p>
          <p className='possible-win-money'>
            {gambleWin * GAMBLE_TYPES_ODD[gambleType]} {currencySymbolOrCode}
          </p>
        </div>
      )}
      {Number.isInteger(gambleType) &&
        isShowGamble &&
        roundStatus === BetStatus.Pending &&
        !isShowGambleWinning && (
          <div className='bonus-win-popup-wrp'>
            <div className='bonus-win-popup-inner'>
              <div className='popup-header'>
                <div className='header-line-left' />
                <p className='popup-header-name'>{t('YOU_WIN')}</p>
                <div className='header-line-right' />
              </div>
              <p className='bonus-win-popup-txt'>
                {gambleWin}
                {currencySymbolOrCode}
              </p>
            </div>
          </div>
        )}
    </div>
  );
});
